import {IFormTemplate, IFormTemplatePage, ISyncField} from "../../../index";
import {FormInput} from "./FormInput";
import {FormHtml} from "./FormHtml";
import {nsForm} from "../nsForm";
import {FormAbstract} from "./FormAbstract";
import ALL_PARTS = nsForm.ALL_PARTS;

export class PageData {
    formParts: FormAbstract[] = [];

    constructor(private template: IFormTemplate, private page: IFormTemplatePage, private syncfields: ISyncField[]) {
        this.formParts = this.getFields();
    }

    getHtml(): string {
        return this.formParts.map(f => f.getHtml()).join('')
    }

    isValid(): boolean {
        return this.formParts.reduce((bool: boolean, fp: FormAbstract) => fp.isValid() && bool, true);
    }

    getSubmitData(): ISyncField[] {
        return this.formParts
            .filter(f => f.name != 'BUTTON')
            .map(f => f.getSubmitData())
            .filter((sf): sf is ISyncField => sf != null);
    }

    getName(field: IField): TFormPartName {
        return (/\[(.*?)[;\]]/gm.exec(field.html ?? '')?.[1] ?? '') as TFormPartName;
    }

    private getFields(): FormAbstract[] {
        const parts: FormAbstract[] = [];
        const b = this.page.body;
        for (let i = 0; i < b.length; i++) {
            const f = nsForm.getRawFormPart(i, b);
            let field: FormAbstract;
            if (this.isFormElement(f)) {
                field = new FormInput(f, this, this.syncfields);
            } else {
                field = new FormHtml(f);
            }
            parts.push(field);
            i = f.end;
        }
        return parts;
    }

    private isFormElement(field: IField): boolean {
        const name = this.getName(field);
        return ALL_PARTS.includes(name);
    }

    dispose() {
        this.formParts.forEach(f => f.dispose());
    }

}